import ws from './webservice'

interface Page {
  pageNumber: number
  pageSize: number
  totalPage: number
  totalElement: number
}

type PageReturn<U, V extends string> = Record<V, U[]> & Record<'page', Page>

// parameters
const SIZE = 500

/**
 * fetch every pages and group results
 * @param key key to extract data
 * @param path api path
 * @param method api method
 * @param body api body
 * @param page current page to fetch
 * @param last results from previous pages
 * @returns
 */
const fetchPages = <U>(
  key: string,
  path: string,
  method: 'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH',
  body?: any,
  page = 0,
  last: U[] = []
): Promise<U[]> => {
  const withParameters = path.includes('?')
  const fullPath = path + (withParameters ? '&' : '?') + `size=${SIZE}&page=${page}`

  return ws<PageReturn<U, typeof key>>(fullPath, method, body).then((res) => {
    // extract datas from object
    const results = res[key]

    if (res.page.totalPage > 1 && res.page.pageNumber < res.page.totalPage) {
      // more to dowload
      return fetchPages(key, path, method, body, page + 1, [...last, ...results])
    }

    //last page return previous results + last page results
    return [...last, ...results]
  })
}

const paramsToSearch = (params: Record<string, any>) => {
  const search = new URLSearchParams()

  Object.keys(params).forEach((key) => {
    const param = params[key]

    if (param) {
      search.append(key, param)
    }
  })

  const query = search.toString()
  return query ? `?${query}` : ''
}

export { fetchPages, paramsToSearch }
